module.exports = __webpack_public_path__ + "img/card-serviceplaces.ee5feb88.svg";